<template>
	<div class="pages">
		<navTop></navTop>
		<div class="box">
			<div
				class="box-li"
				v-for="(item, index) in list"
				:key="index"
				@click="goWorkStart(item.path)"
			>
				<p>{{ item.text }}</p>
				<img src="../../assets/left.png" />
			</div>
		</div>
	</div>
</template>

<script>
import navTop from '../../components/navTop.vue';
export default {
	name: 'workProgress',
	components: {
		navTop
	},
	data() {
		return {
			height: '',
			list: [
				{ text: 'Genaral Information', path: '/workStart1' },
				{ text: 'Preloading suevey', path: '/workStart2' },
				{ text: 'Hold Inspection', path: '/workStart3' },
				{ text: 'Final Report', path: '/workStart4' },
				{ text: 'Cargo information', path: '/workStart5' }
			],
			id: ''
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			this.id = this.$route.query.id;
		}
	},
	methods: {
		goWorkStart(path) {
			this.$router.push({ path: path, query: { id: this.id } });
		}
	}
};
</script>

<style lang="scss" scoped>
.pages {
	background: #3E414A;
	.box {
		width: 100%;
		margin: 0 auto;
		padding-top: 109px;
		padding-bottom: 118px;
		box-sizing: border-box;
		.box-li {
			width: 100%;
			height: 100px;
			border: 1px solid rgba(0, 255, 255, 0.25);
			border-radius: 10px;
			background: #053134;
			margin-bottom: 28px;
			padding: 0 55px;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: space-between;
			p {
				font-size: 30px;
				color: #1bf6ff;
				line-height: 1em;
			}
			img {
				width: 23px;
				height: 41px;
				display: block;
			}
		}
		.box-li:last-child {
			margin: 0;
		}
	}
}
</style>
